import s from './List.scss'
import MaterialTable, { MTableBodyRow } from '@material-table/core'
import { FaCaretDown, FaCaretUp } from 'react-icons/fa'
import { Checkbox } from 'components/ideal-core-ui'

const List = ({
  stages,
  moveStageUp,
  moveStageDown,
  removeStage,
  openEditStage,
  changeVisibility,
  title,
  admin
}) => {
  const columns = [
    {
      title: 'Pos',
      field: 'orderIndex',
      sorting: false,
      width: 30,
      align: 'center',
      render: row => (
        <div>
          <div>
            {!row.isFirst && <FaCaretUp className={s.moveIcon} onClick={() => moveStageUp(row)} />}
          </div>
          <div>
            {!row.isLast && (
              <FaCaretDown className={s.moveIcon} onClick={() => moveStageDown(row)} />
            )}
          </div>
        </div>
      )
    },
    { title: 'Name', field: 'name', sorting: false },
    { title: 'Stage Label', field: 'label', sorting: false },
    {
      title: 'Category',
      field: 'category',
      sorting: false,
      render: row => row.category.name
    },
    {
      title: 'Color',
      field: 'color',
      sorting: false,
      width: 40,
      align: 'center',
      render: row => (
        <div
          className={s.stageColor}
          style={{ backgroundColor: row.color || row.category.color }}
        />
      )
    },
    {
      title: 'Visible on the Pipeline Board',
      field: 'visibleOnBoardLanes',
      align: 'center',
      sorting: false,
      render: row => (
        <Checkbox
          isChecked={row.visibleOnBoardLanes}
          triggerCheckbox={value => changeVisibility(value.target.checked, row)}
          name="visibleOnBoardLanes"
        />
      )
    }
  ]

  return (
    <div className={s.listWrapper}>
      <MaterialTable
        title={title}
        columns={columns}
        data={stages}
        components={{
          Row: props => <MTableBodyRow id={`pipeline_row_${props.data.id}_cy`} {...props} />
        }}
        options={{
          actionsColumnIndex: -1,
          sorting: true,
          headerStyle: {
            backgroundColor: '#eee',
            color: '#000',
            position: 'sticky',
            top: 0,
            zIndex: 1,
            fontSize: '14px'
          },
          pageSize: 20,
          pageSizeOptions: [5, 10, 20, 50],
          padding: 'dense'
        }}
        style={{
          boxShadow: 'none',
          fontSize: '14px'
        }}
        actions={
          admin
            ? [
                () => ({
                  icon: 'edit',
                  tooltip: 'Edit Pipeline Stage',
                  onClick: (event, rowData) => openEditStage(rowData)
                }),
                rowData => ({
                  icon: 'delete',
                  tooltip: 'Delete Pipeline Stage',
                  isFreeAction: true,
                  onClick: (event, rowData) => {
                    removeStage(rowData)
                  },
                  disabled: rowData.system
                })
              ]
            : []
        }
      />
    </div>
  )
}

export default List
